'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * FocalPoint
 * The container that will maintain focus
 */

var React = require('react');
var stack = [];
var timer = null;

/**
 * To support server-side rendering, do not push the active element
 * when not in the browser environment
 */
if (typeof document !== 'undefined' && document.activeElement) {
  stack.push(document.activeElement);
}

var FocalPoint = function (_React$Component) {
  _inherits(FocalPoint, _React$Component);

  function FocalPoint() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FocalPoint);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FocalPoint.__proto__ || Object.getPrototypeOf(FocalPoint)).call.apply(_ref, [this].concat(args))), _this), _this._onBlur = function (event) {
      var current = stack[stack.length - 1];

      if (current && current.contains(event.target) === false) {
        event.preventDefault();
        _this.trapFocus();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FocalPoint, [{
    key: 'contains',
    value: function contains(element) {
      return this.refs.root.contains(element);
    }
  }, {
    key: 'focus',
    value: function focus() {
      if (this.contains(document.activeElement) === false) {
        this.refs.root.focus();
      }
    }
  }, {
    key: 'trapFocus',
    value: function trapFocus(e) {
      clearTimeout(timer);
      timer = setTimeout(function (_) {
        return stack[stack.length - 1].focus();
      }, 10);
    }
  }, {
    key: 'returnFocus',
    value: function returnFocus() {
      var anchor = this.state.anchor;

      // When transitioning between pages using hash route state,
      // this anchor is some times lost. Do not attempt to focus
      // on a non-existent anchor.

      if (anchor && (typeof anchor === 'undefined' ? 'undefined' : _typeof(anchor)) === 'object' && typeof anchor.focus === 'function') {
        anchor.focus();
      }
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof document !== 'undefined') {
        this.setState({ anchor: document.activeElement });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      stack.push(this);

      this.trapFocus();

      document.addEventListener('focus', this._onBlur, true);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _this2 = this;

      stack = stack.filter(function (i) {
        return i !== _this2;
      });

      document.removeEventListener('focus', this._onBlur, true);

      clearTimeout(timer);

      this.returnFocus();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          Element = _props.element,
          className = _props.className;


      return React.createElement(
        Element,
        { ref: 'root', tabIndex: '0', className: className },
        children
      );
    }
  }]);

  return FocalPoint;
}(React.Component);

FocalPoint.defaultProps = {
  element: 'div'
};


module.exports = FocalPoint;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ../~/react-focus-trap/src/focal-point.js
// module id = 1024
// module chunks = 0 1 2 3 4 5 6 7 8 9 10